import React, { useState, useRef } from "react";
import { StandaloneSearchBox } from "@react-google-maps/api";
import "../../styles/SearchGoogleLandmark.css";

const SearchGoogleLandmark = ({ setLandmark, title, location }) => {
  const [inputValue, setInputValue] = useState(location?.address || ""); // Local state to manage input value
  const inputRef = useRef(null);

  const handleOnPlacesChanged = () => {
    const address = inputRef.current.getPlaces();
    
    const selectedPlace = address[0];

    if (selectedPlace) {
      const landmarkData = {
        address: selectedPlace.formatted_address || "",
        lat: selectedPlace.geometry?.location.lat() || "",
        lng: selectedPlace.geometry?.location.lng() || "",
      };

      setLandmark(landmarkData);

      setInputValue(selectedPlace.formatted_address || "");
    }
  };

  const handleOnChange = (event) => {
    setInputValue(event.target.value);
  };

  return (
    <>
      <label
        htmlFor="addressInput"
        className="block text-sm font-medium text-gray-700 mb-2"
      >
        {title}
      </label>
      <StandaloneSearchBox
        onLoad={(ref) => (inputRef.current = ref)}
        onPlacesChanged={handleOnPlacesChanged}
      >
        <input
          type="text"
          className="w-full text-sm border border-gray-300 rounded-lg py-2 px-3 
          text-gray-700 focus:border-blue-500 focus:ring-blue-500 focus:outline-none"
          placeholder="Select Address"
          value={inputValue} 
          onChange={handleOnChange}
        />
      </StandaloneSearchBox>
    </>
  );
};

export default SearchGoogleLandmark;
